import { render } from "./Plate.vue?vue&type=template&id=b3b92e80&ts=true"
import script from "./Plate.vue?vue&type=script&lang=ts"
export * from "./Plate.vue?vue&type=script&lang=ts"

import "./Plate.vue?vue&type=style&index=0&id=b3b92e80&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__